"use client";

import { getCurrencySymbolFromCode } from "@web/lib/currency";
import { shortId } from "@web/lib/utils";
import { useMemo } from "react";
import { Log, LogType } from "./ClientDashboard";

function formatPrice(log: Log) {
  const value = typeof log.price?.value === "number" ? log.price.value : 0;
  return `${value.toFixed(4)}${getCurrencySymbolFromCode(log.price?.currency)}`;
}

export function Activity({ log }: { log: Log }) {
  const date = useMemo(() => new Date(log.timestamp), [log.timestamp]);
  switch (log.type) {
    case LogType.InvoicePaid:
      return (
        <tr className="!border-none text-sm text-white ">
          <td className="py-5 border-b	border-[#3B82F6]" title={date.toLocaleString()}>
            {date.toTimeString().split(" ")[0]}
          </td>
          <td className="py-5 border-b	border-[#3B82F6]">Invoice Paid</td>
          <td className="py-5 border-b	border-[#3B82F6]">{shortId(log.relatedId)}</td>
          <td className="py-5 border-b	border-[#3B82F6]">{formatPrice(log)}</td>
        </tr>
      );
    case LogType.SubscriptionRequest:
      return (
        <tr className="!border-none text-sm border-[#EEEEEE]">
          <td className="py-5 border-b	border-[#3B82F6]" title={date.toLocaleString()}>
            {date.toTimeString().split(" ")[0]}
          </td>
          <td className="py-5 border-b	border-[#3B82F6]">Subscription Request</td>
          <td className="py-5 border-b	border-[#3B82F6]">{shortId(log.relatedId)}</td>
          <td className="py-5 border-b	border-[#3B82F6]">{formatPrice(log)}</td>
        </tr>
      );
    case LogType.PayAsYouGoRequest:
      return (
        <tr className="!border-none text-sm border-[#EEEEEE]">
          <td className="py-5 border-b	border-[#3B82F6]" title={date.toLocaleString()}>
            {date.toTimeString().split(" ")[0]}
          </td>
          <td className="py-5 border-b	border-[#3B82F6]">Paid Request</td>
          <td className="py-5 border-b	border-[#3B82F6]">{shortId(log.relatedId)}</td>
          <td className="py-5 border-b	border-[#3B82F6]">{formatPrice(log)}</td>
        </tr>
      );
  }
}
